/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-01-30 11:19:38
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-05-20 09:21:19
 * @FilePath: \vue-hepha-order\src\views\base\queryConfig\EditForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 编辑国家代码配置
const EditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'150px',
    formData:{},
    formField:[
        {
            name:'setting.countryLocal',
            key:'country_local',
            type:'input',
            width:'300px',
            placeholder:'base.input',
        },
        // {
        //     name:'order.frameNumber',
        //     key:'attribute1',
        //     type:'input',
        //     width:'300px',
        //     placeholder:'base.input',
        // },
        // {
        //     name:'order.logistics',
        //     key:'attribute2',
        //     type:'input',
        //     width:'300px',
        //     placeholder:'base.input',
        // },
        {
            name:'config.eu_flag',
            key:'eu_flag',
            type:'select',
            width:'300px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label: 'base.yes',
                    value: 1
                },
                {
                    label: 'base.no',
                    value: 0
                }
            ]
        },
        {
            name:'config.lang',
            key:'lang',
            type:'select',
            width:'300px',
            placeholder:'base.select',
            optionToLocale:true,
            options:[
                {
                    label: 'base.en',
                    value: 'EN'
                },
                {
                    label: 'base.de',
                    value: 'DE'
                }
            ]
        },
        {
            name:'config.enable',
            key:'enable_flag',
            type:'switch',
            width:'300px',
        },
    ]
}

EditForm.formField.forEach(item=>{
    EditForm.formData[item.key] = ''
})

export {
    EditForm,
}